import { Icon } from "components/index";
import { IMAGE } from "icons";
import { assetUrl } from "utils/index";

// Project column for projects__integrations rows: same look as ProjectNameCell,
// but reads the project from the `projects` relation instead of the row itself.
export const IntegrationProjectCell = ({ getValue }) => {
  const project = getValue();
  if (!project) return <span className="text-gray-400">—</span>;
  const { logo, name } = project;
  return (
    <div className="flex items-center gap-2">
      <div className="overflow-hidden rounded size-8">
        {logo ? (
          <img src={assetUrl(logo)} alt={`${name} logo`} className="w-full h-full object-contain" />
        ) : (
          <div className="w-full h-full flex items-center justify-center rounded bg-neutral">
            <Icon icon={IMAGE} className="size-full text-input" />
          </div>
        )}
      </div>
      <span>{name}</span>
    </div>
  );
};

// Fields for the project relation, shared by every integration list.
export const PROJECT_FIELDS = ["projects.id", "projects.name", "projects.logo", "projects.project_id"];

// Search box filters by project name (Directus `search` only covers the junction's own fields).
export const projectNameSearch = (search) => ({ projects: { name: { _icontains: search.trim() } } });
